import { format } from 'date-fns';
import { formatFileSize } from '@utils/lib/formatFileSize';

/** size приходит строкой — приводим к числу байт. */
export const parseSize = (size) => {
	const parsed = Number(size);
	return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

/** Расширение без точки, в нижнем регистре: из поля extension либо из имени файла. */
export const getExtension = (attachment) => {
	const raw = attachment?.extension || attachment?.name?.split('.').pop() || '';
	return String(raw).replace(/^\./, '').toLowerCase();
};

/** Laravel отдаёт 'Y-m-d H:i:s' — нормализуем под Date (Safari не ест пробел). */
export const formatAttachmentDate = (createdAt) => {
	if (!createdAt) return '';
	const date = new Date(String(createdAt).replace(' ', 'T'));
	if (Number.isNaN(date.getTime())) return '';
	return format(date, 'dd.MM.yyyy');
};

/** Единая форма Attachment для UI: иконки, размеры, подписи. */
export const normalizeAttachment = (attachment) => ({
	...attachment,
	extension: getExtension(attachment),
	sizeLabel: formatFileSize(parseSize(attachment?.size)),
	dateLabel: formatAttachmentDate(attachment?.created_at),
});
